<template>
  <h1>hola</h1>
 <imgexpand src='assets/drawing5.jpg'/>
  <imgexpand src='assets/drawing4.jpg'/>
</template>

<script>
import imgexpand from "./imgexpand.vue";
export default {
  components: {
    imgexpand
  }
};
</script>

<style>
</style>